<template>
  <a-month-picker @change="valueChange" :allowClear="allowClear" v-model="dateValue" v-bind="$attrs" v-on="$listeners"
                  :class="blackhillsYellow ? 'blackhillsYellow' : ''"
  ></a-month-picker>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ptMonthPicker',
  props: {
    blackhillsYellow: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Array],
    },
    formatStr: {
      type: String,
      default: "YYYY-MM-DD"
    }
  },
  data() {
    return {
      dateValue: undefined
    }
  },
  mounted() {
    let val = this.value
    console.log(val)
    if (val == '~') {
      this.dateValue = undefined
    } else {
      if (typeof (val) == 'string') {
        this.dateValue = moment(val, this.formatStr)
      } else {
        this.dateValue = val
      }
    }
  },
  watch: {
    value(val) {
      console.log(val)
      if (val == '~') {
        this.dateValue = undefined
      } else {
        if (typeof (val) == 'string') {
          this.dateValue = moment(val, this.formatStr)
        } else {
          this.dateValue = val
        }
      }
    },
    dateValue(val) {
      if (val) {
        let value = moment(val).format(this.formatStr)
        this.$emit('input', value)
      } else {
        this.$emit('input', val)
      }

    }
  },
  methods: {
    valueChange(val) {
      // let value = moment(val).format('YYYY-MM-DD')
      this.$emit('input', this.dateValue)
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../core/diy";

.blackhillsYellow {
  /deep/ input {
    font-size: 12px;
    color: @blackhills-yellow;
  }
}
</style>
